export default "__VITE_ASSET__C8q8zpDT__"